export default {
  sm: '0 2px 5px 0 rgba(0, 0, 0, 0.5)',
  //in progress of new shadow definition
  unstable_new: {
    sm: 'none',
    md: '0 2px 4px 0 rgba(0, 0, 0, 0.25)',
    lg: '0 4px 5px 0 rgba(0, 0, 0, 0.2), 0 3px 14px 3px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14)',
    xl: '0 24px 24px 0 rgba(0, 0, 0, 0.3), 0 0 24px 0 rgba(0, 0, 0, 0.22)',
  },
};
